"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorsMixin = exports.backgroundColorMixin = exports.colorMixin = void 0;

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../utils");

var colorMixinBase = function colorMixinBase(_ref) {
  var color = _ref.color,
      theme = _ref.theme;
  return (0, _utils.cssPropWithFallthrough)('color', color, theme.selectors.colorOrNull);
};

var colorMixin = (0, _stencilReactDesc.describe)(colorMixinBase).description('Adds a prop for CSS color.');
exports.colorMixin = colorMixin;
colorMixin.propTypes = {
  color: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'color' property for the element.")
};

var backgroundColorMixinBase = function backgroundColorMixinBase(_ref2) {
  var backgroundColor = _ref2.backgroundColor,
      theme = _ref2.theme;
  return (0, _utils.cssPropWithFallthrough)('background-color', backgroundColor, theme.selectors.colorOrNull);
};

var backgroundColorMixin = (0, _stencilReactDesc.describe)(backgroundColorMixinBase).description('Adds a prop for CSS background-color.');
exports.backgroundColorMixin = backgroundColorMixin;
backgroundColorMixin.propTypes = {
  backgroundColor: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'background-color' property for the element.")
};
var colorsMixin = (0, _utils.combineMixins)(colorMixin, backgroundColorMixin);
exports.colorsMixin = colorsMixin;